var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgUpload2 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.999,
    height: 18,
    viewBox: "0 0 12.999 18",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-3621.805,8338v-13.014l-5.16,5.228-.785-.8,6.5-6.583,6.5,6.583-.785.8-5.16-5.228V8338Zm-5.945-16.874V8320h13v1.126Z",
    transform: "translate(3630.25 -8320)"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgUpload2);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/upload2.2a1b00cd53f157eea286255b4a01d842.svg";